/**
 * Identifica un inicio de sesión concreto de una persona. Sirve de clave para recordar que la ventana
 * de regularización ya se cerró: otra persona, o la misma tras un nuevo login, tiene otra clave.
 */
export function claveInicioSesion(userId: string | null, inicioSesion: string): string | null {
  return userId && inicioSesion !== '' ? `${userId}:${inicioSesion}` : null;
}

interface EstadoVentana {
  readonly sesion: string | null;
  readonly cerradaEnSesion: string | null;
  readonly yaVistaEnEstaSesion: boolean;
  readonly hayEntidad: boolean;
  readonly cantidadVencidos: number;
}

/** La ventana se abre una vez por inicio de sesión, solo si hay algo vencido que mostrar. */
export function ventanaRegularizacionAbierta(estado: EstadoVentana): boolean {
  const { sesion, cerradaEnSesion, yaVistaEnEstaSesion, hayEntidad, cantidadVencidos } = estado;
  return sesion !== null
    && cerradaEnSesion !== sesion
    && !yaVistaEnEstaSesion
    && hayEntidad
    && cantidadVencidos > 0;
}

/** Faltantes vencidos tal como llegaron de la base, con la entidad para la que se pidieron. */
export interface VencidosCargados<T> {
  readonly entidadClave: string;
  readonly faltantes: readonly T[];
}

export function claveEntidadDinero(entidad: { readonly tipo: string; readonly id: string } | null): string | null {
  return entidad ? `${entidad.tipo}:${entidad.id}` : null;
}

/**
 * Los vencidos solo valen para la entidad que se consultó. Tras un logout, un cambio de identidad o una
 * carga fallida, lo que quedó de otra entidad no se muestra: falla cerrado hacia "nada que mostrar".
 * No borra nada en la base; al volver la entidad original, se recarga.
 */
export function vencidosDeLaEntidad<T>(
  cargados: VencidosCargados<T> | null,
  entidadClave: string | null,
): readonly T[] {
  return cargados !== null && entidadClave !== null && cargados.entidadClave === entidadClave
    ? cargados.faltantes
    : [];
}
